import {
  Button, Col, Form, InputGroup, Row,
} from 'react-bootstrap';
import React, { useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import FileIcon from '../../UI/icons/FileIcon.jsx';
import fetchConfig from '../../../fetchConfig';
import ConfirmModal from '../../common/ConfirmModal';
import useAPI from '../../../hooks/useAPI';
import './AttachmentItem.less'

export default function AttachmentItem({
  url, info, onDelete, onChange, attachments, disabled
}) {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [validatedEdit, setValidatedEdit] = useState(false);
  const [newName, setNewName] = useState('');
  const [error, setError] = useState(false)
  const api = useAPI();

  const token = sessionStorage.getItem('kctoken');

  const download = async () => {
    setLoading(true);
    const resp = await fetch(fetchConfig.baseUrl + url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (resp.ok) {
      if (resp.headers.get('Content-Type') === 'application/octet-stream') {
        const blob = await resp.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = resp.headers.get('fileName')
          ? decodeURIComponent(resp.headers.get('fileName'))
          : info.name;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(link);
        }, 200);
      }
    }
    setLoading(false);
  };

  const handleEdit = () => {
    // чтоб нельзя было ввести пустые пробелы
    if (!newName.trim()) {
      setNewName('');
      setError(true);
      return;
    }

    const attachmentIndex = attachments.indexOf(attachments.find((a) => a.id === info.id));
    attachments[attachmentIndex] = { ...attachments[attachmentIndex], fileName: newName, renamed: true };
    onChange(attachments, 'attachments');
    setIsEditMode(false);
    setError(false);
  };

  const handleEditCancel = () => {
    setIsEditMode(false);
    setError(false);
    setNewName('');
  };

  return (
    <div className='attachments-item'>
      <div className="d-flex gap-2 align-items-center" style={{ textDecoration: 'none', width: 'max-content', maxWidth: '100%' }}>
        <FileIcon mimetype={info.contentType} style={{ maxHeight: 32 }} />
        <div>
          {isEditMode
            ? (
              <Form.Group>
                <InputGroup style={{width: 300}}>
                  <Form.Control size="sm" value={newName} onChange={(event) => setNewName(event.target.value)} />
                  <Button onClick={handleEdit} variant="light" size="sm" style={{ background: 'transparent', border: '1px solid #ccc' }}><CheckIcon style={{ opacity: 0.5 }} /></Button>
                  <Button onClick={handleEditCancel} variant="light" size="sm" style={{ background: 'transparent', border: '1px solid #ccc' }}><CloseIcon style={{ opacity: 0.5 }} /></Button>
                </InputGroup>
                {error && <Form.Text style={styledAlert}>Введите название приложения</Form.Text>}
              </Form.Group>

            ) : (
              <div className="d-flex justify-content-between gap-3">
                <span
                  className="text-primary text-decoration-underline d-block mr-2"
                  style={{ cursor: 'pointer', textUnderlinePosition: 'under' }}
                  onClick={!loading ? download : null}
                >
                  {newName || info.fileName}
                </span>
                <div className="d-flex gap-2">
                  <button disabled={disabled} onClick={() => setIsEditMode(true)} className="d-flex align-items-center justify-content-center" style={styledEditBtn}>
                    <EditIcon style={{color: '#0D6EFD'}}/>
                  </button>
                  <Button disabled={disabled} onClick={() => setShowModal(true)} variant="light" className="btn-close" size="md" />
                </div>
              </div>
            )}
          <div className="d-flex gap-3 metadata">
            <span style={{ color: '#7B8592' }}>{new Date(info?.createdOn).toLocaleDateString('ru-RU')}</span>
            <span style={{ color: '#7B8592' }}>
              {(info.contentLength / 8 / 1024).toFixed(2)}
              {' '}
              Кбайт
            </span>
          </div>
        </div>
      </div>
      <ConfirmModal
        show={showModal}
        onConfirm={() => {
          api.del(`/minioFiles/remove/${info.id}`);
          setShowModal(false);
          onDelete(info.number);
        }}
        onClose={() => setShowModal(false)}
        message="Файл будет удалён с сервера без возможности восстановления. Вы уверены?"
      />
    </div>
  );
}

const styledEditBtn = {
  border: 'none',
  background: 'none',
  width: 24,
  height: 24,
};
const styledAlert = { fontSize: '14px', lineHeight: '20px', color: '#dc3545' }
